/* eslint-disable no-magic-numbers */

import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from 'carbon-react/lib/components/button';

import { CalendarGrids } from '@futrli/ui-components';

import { useConsolidationContext } from '../../../consolidation-context/consolidation-context';
import styles from './fx-rates-currency-calendar.scss';

export const FxRatesCurrencyCalendar = () => {
  const [today] = useState(new Date());
  const {
    dailyFxRates: { gridData, handleEditFxRateOverrides }
  } = useConsolidationContext();

  return (
    <div>
      <div className={styles.ctaBar}>
        <Button size="small" onClick={handleEditFxRateOverrides} buttonType="primary" ml="6px">
          <FormattedMessage id="consolidation.edit_daily_fx_rates" defaultMessage="Edit daily FX rates" />
        </Button>
      </div>

      {gridData && <CalendarGrids data={gridData} scrollToOnInit={today} />}
    </div>
  );
};
